import { useState, useEffect } from "react";
import type { GhostPost, SelectResultFn } from "../../types";
import PostListItem from "./PostListItem";
import ShowMoreButton from "./ShowMoreButton";

const DEFAULT_MAX_POSTS = 10;

interface PostResultsProps {
  posts: GhostPost[];
  selectedResult: string | null;
  setSelectedResult: SelectResultFn;
}

export default function PostResults({
  posts,
  selectedResult,
  setSelectedResult,
}: PostResultsProps) {
  const [maxPosts, setMaxPosts] = useState(DEFAULT_MAX_POSTS);

  useEffect(() => {
    setMaxPosts(DEFAULT_MAX_POSTS);
  }, [posts]);

  if (!posts?.length) {
    return null;
  }

  const paginatedPosts = posts.slice(0, maxPosts);

  return (
    <div className="border-t border-neutral-200 py-3 px-4 sm:px-7">
      <h1 className="uppercase text-xs text-neutral-400 font-semibold mb-1 tracking-wide">
        Posts
      </h1>
      {paginatedPosts.map((post) => (
        <PostListItem
          key={post.title}
          post={post}
          selectedResult={selectedResult}
          setSelectedResult={setSelectedResult}
        />
      ))}
      <ShowMoreButton
        setMaxPosts={setMaxPosts}
        maxPosts={maxPosts}
        posts={posts}
      />
    </div>
  );
}
